export const SheetDefaults = {
  scrollBarHeight: 15,
  scrollBarWidth: 15,

  statusBarHeight: 25,
  defaultColWidth: 155,
  defaultRowHeight: 28,

  freezeBarHandleSize: 4,

  groupBarHeight: 28,
  columnHeaderHeight: 25,
  formulaBarHeight: 28,
  filterBarHeight: 28,
  rowHeaderWidth: 45,
  resizerLineSize: 4,
  rightShortcutBarWidth: 30,

  rowGroupBarWidth: 28,

  unHideIconSize: 12,

  minEntitySize: 3,
} as const;
